import api from '../../services/api';

/** Same contract as GET /dashboard/filters — used only for Bandwidth filter dropdowns. */
export interface BandwidthFilterOptionsData {
  date: { years: number[]; months: string[]; days: number[] };
  ticketTypes: string[];
  priorities: string[];
  states: string[];
  customers: { id: string; accountName: string }[];
  assignmentGroups: { id: string; name: string }[];
}

export async function fetchBandwidthFilterOptions(): Promise<BandwidthFilterOptionsData> {
  const response = await api.get<{ success: boolean; data: BandwidthFilterOptionsData }>('/dashboard/filters');
  if (!response.data?.success || !response.data.data) {
    throw new Error('Invalid bandwidth filter options response');
  }
  return response.data.data;
}
